import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import ImageSlider from "@components/ui/ImageSlider";

export default class ProductGallery extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);
    
    let imageSlider = new ImageSlider(this.$root.find(`[component="image-slider"]`)[0] as ComponentElem);

    this.$root.find(`.btn-prev`).on("click", (event:Event)=>
    {
      event.preventDefault();
      imageSlider.toPrev();
    });

    this.$root.find(`.btn-next`).on("click", (event:Event)=>
    {
      event.preventDefault();
      imageSlider.toNext();
    });
  }
}